import { anatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

/**
 * ConfirmationDialog — applied over the `Modal` parts with `sx`, so it does not touch the
 * `Modal` config other dialogs use.
 */
const confirmationDialogAnatomy = anatomy('confirmationDialog').parts(
  'dialog',
  'header',
  'closeButton',
  'body',
  'footer',
  'confirmButton'
);

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(confirmationDialogAnatomy.keys);

export const styleConfig = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    dialog: {
      bg: 'neutral.bg-primary',
      borderRadius: '3xl',
      // Keeps a narrow viewport's gutter instead of running edge to edge.
      mx: '4',
      p: { base: '4', xs: '5' },
      gap: '4',
    },
    header: { p: '0', display: 'flex', flexDirection: 'column', gap: '4' },
    closeButton: { position: 'static', flexShrink: 0 },
    body: { p: '0', display: 'flex', flexDirection: 'column', gap: '4' },
    footer: { p: '0', display: 'grid', gap: '4' },
  }),
  // Cancel comes first in the DOM, so a row ends on the key action; stacked, `order` lifts the
  // key action on top. Kept whole per size — a responsive object would replace, not merge with,
  // a base value.
  sizes: {
    sm: definePartsStyle({
      dialog: { maxW: '100' },
      footer: { gridTemplateColumns: '1fr', justifyContent: 'stretch' },
      confirmButton: { order: -1 },
    }),
    md: definePartsStyle({
      dialog: { maxW: '120' },
      footer: {
        gridTemplateColumns: { base: '1fr', xs: 'repeat(2, max-content)' },
        justifyContent: { base: 'stretch', xs: 'end' },
      },
      confirmButton: { order: { base: -1, xs: 0 } },
    }),
  },
  defaultProps: { size: 'sm' },
});
